module.exports = __webpack_public_path__ + "img/information.d1edf35c.svg";